var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{attrs:{"justify":"space-around","max-width":"820px"}},[_c('reflection-entry')],1),_vm._l((_vm.reflections),function(reflection){return _c('reflection-item',{key:reflection.id,attrs:{"reflection":reflection}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }